import React from 'react';
import { Heart, Sparkle, Flower2, Wine } from 'lucide-react';

type ConfettiPiece = {
  Icon: typeof Heart;
  className: string;
  wrapperStyle: React.CSSProperties;
  animationClass: string;
  desktopOnly?: boolean;
};

const pieces: ConfettiPiece[] = [
  {
    Icon: Heart,
    className: 'h-6 w-6 text-rose-400/60',
    wrapperStyle: { top: '6%', left: '4%', transform: 'rotate(12deg)' },
    animationClass: 'motion-safe:animate-float',
  },
  {
    Icon: Sparkle,
    className: 'h-7 w-7 text-amber-400/70',
    wrapperStyle: { top: '8%', right: '5%', transform: 'rotate(-12deg)' },
    animationClass: 'motion-safe:animate-float-delayed',
  },
  {
    Icon: Flower2,
    className: 'h-6 w-6 text-pink-400/60',
    wrapperStyle: { bottom: '10%', left: '6%', transform: 'rotate(6deg)' },
    animationClass: 'motion-safe:animate-float-slow',
  },
  {
    Icon: Wine,
    className: 'h-6 w-6 text-rose-400/50',
    wrapperStyle: { bottom: '8%', right: '6%', transform: 'rotate(3deg)' },
    animationClass: 'motion-safe:animate-float',
  },
  {
    Icon: Heart,
    className: 'h-5 w-5 text-amber-400/50',
    wrapperStyle: { top: '45%', left: '2%', transform: 'rotate(45deg)' },
    animationClass: 'motion-safe:animate-float-delayed',
  },
  {
    Icon: Sparkle,
    className: 'h-8 w-8 text-pink-400/50',
    wrapperStyle: { top: '15%', left: '18%' },
    animationClass: 'motion-safe:animate-float-slow',
    desktopOnly: true,
  },
  {
    Icon: Flower2,
    className: 'h-7 w-7 text-rose-400/50',
    wrapperStyle: { top: '20%', right: '16%', transform: 'rotate(-8deg)' },
    animationClass: 'motion-safe:animate-float',
    desktopOnly: true,
  },
  {
    Icon: Heart,
    className: 'h-6 w-6 text-yellow-400/60',
    wrapperStyle: { bottom: '20%', left: '20%', transform: 'rotate(-15deg)' },
    animationClass: 'motion-safe:animate-float-delayed',
    desktopOnly: true,
  },
  {
    Icon: Wine,
    className: 'h-8 w-8 text-amber-400/50',
    wrapperStyle: { top: '40%', right: '8%', transform: 'rotate(10deg)' },
    animationClass: 'motion-safe:animate-float-slow',
    desktopOnly: true,
  },
  {
    Icon: Sparkle,
    className: 'h-6 w-6 text-rose-400/60',
    wrapperStyle: { bottom: '25%', right: '22%' },
    animationClass: 'motion-safe:animate-float',
    desktopOnly: true,
  },
  {
    Icon: Flower2,
    className: 'h-5 w-5 text-pink-400/40',
    wrapperStyle: { top: '10%', right: '35%', transform: 'rotate(20deg)' },
    animationClass: 'motion-safe:animate-float-delayed',
    desktopOnly: true,
  },
];

export const HeroConfetti: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {pieces.map(({ Icon, className, wrapperStyle, animationClass, desktopOnly }, idx) => (
        <span
          key={idx}
          className={`absolute ${desktopOnly ? 'hidden md:block' : ''}`}
          style={wrapperStyle}
        >
          <Icon className={`${className} ${animationClass}`} strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );
};
